module.exports = __webpack_public_path__ + "img/pebec-logo.fec94c6c.png";